import { EMPTY_GUID } from '@src/constants/guids';
import { FavoritterContext } from '@src/types/FavoritterContext';
import { LagtTilAvType, VerktoyType, type MittVerktoyItem } from '@src/types/minhelseentities';

import type { WebCompFavoritterProps } from '@src/types/WebCompFavoritterProps';

import { KATALOG_ELEMENT_GUIDS, PARAMS } from './favoritter-config';

type MineVerktoyProps = { context: FavoritterContext.MineVerktoy; item: MittVerktoyItem };
type FinnVerktoyProps = { context: FavoritterContext.FinnVerktoy };
type FavoritterWrapperProps = MineVerktoyProps | FinnVerktoyProps;

const lagFavorittNavn = (item: MittVerktoyItem, inkluderBegrunnelse: boolean): string => {
  if (inkluderBegrunnelse && item.LagtTilAvTypeId === LagtTilAvType.Behandler && item.Begrunnelse) {
    return `${item.VerktoyNavn} - ${item.Begrunnelse}`;
  }
  return item.VerktoyNavn;
};

const erWeblosning = (item: MittVerktoyItem): boolean => item.VerktoyType.includes(VerktoyType.Weblosning);
const erApp = (item: MittVerktoyItem): boolean => item.VerktoyType.includes(VerktoyType.App);
const erNasjonaltVerktoy = (item: MittVerktoyItem): boolean => !item.KreverForskrivning;

const getWebCompProps = (props: FavoritterWrapperProps): WebCompFavoritterProps => {
  if (props.context === FavoritterContext.FinnVerktoy) {
    return { elementguid: KATALOG_ELEMENT_GUIDS.finn_verktoy };
  }

  const { item } = props;
  const navn = lagFavorittNavn(item, erWeblosning(item));

  if (erWeblosning(item)) {
    const aktivitetId = erNasjonaltVerktoy(item) ? EMPTY_GUID : item.LaeringsaktivitetGuid;
    return {
      elementguid: KATALOG_ELEMENT_GUIDS.verktoy_eksternt_uthopp,
      elementparameters: `${PARAMS.verktoyId}=${item.VerktoyId}${PARAMS.separator}${PARAMS.aktivitetId}=${aktivitetId}`,
      navn,
    };
  }

  if (erApp(item)) {
    return {
      elementguid: KATALOG_ELEMENT_GUIDS.verktoy_detaljside,
      elementparameters: `${PARAMS.verktoyId}=${item.VerktoyId}`,
      navn,
    };
  }

  return {
    elementguid: KATALOG_ELEMENT_GUIDS.verktoy_detaljside,
    elementparameters: `${PARAMS.verktoyId}=${item.VerktoyId}`,
    navn,
  };
};

const FavoritterWrapper = (props: FavoritterWrapperProps): React.JSX.Element => {
  const webCompProps = getWebCompProps(props);

  return (
    <span>
      <hn-webcomp-favoritter {...webCompProps}></hn-webcomp-favoritter>
    </span>
  );
};

export default FavoritterWrapper;
